import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ThemeService, ThemeType } from '../../../services/theme.service';

@Component({
  selector: 'app-theme-switcher',
  templateUrl: './theme-switcher.component.html',
  styleUrls: ['./theme-switcher.component.css'],
  standalone: false
})
export class ThemeSwitcherComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  currentTheme: ThemeType = 'red';
  availableThemes: { value: ThemeType; label: string; color: string }[] = [];

  constructor(private themeService: ThemeService) {}

  ngOnInit(): void {
    this.currentTheme = this.themeService.getCurrentTheme();
    this.availableThemes = this.themeService.getAvailableThemes();

    this.themeService.currentTheme$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(theme => {
      this.currentTheme = theme;
    });
  }

  /**
   * Change theme
   */
  changeTheme(theme: ThemeType): void {
    this.themeService.setTheme(theme);
  }

  /**
   * Toggle to next theme
   */
  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  /**
   * Get theme color for display
   */
  getThemeColor(theme: ThemeType): string {
    const themeConfig = this.availableThemes.find(t => t.value === theme);
    return themeConfig?.color || '#bf1a47';
  }
} 